import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 2rem;
  & .left-title {
    text-align: left;
  }
  & .top-form {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    text-align: left;
  }
  & .form-fields {
    display: flex;
    flex-wrap: wrap;
    & .field {
      margin: 0.5rem;
      min-width: 48%;
      & .hefesto-textfield {
        max-height: 3rem;
      }
    }
    & .field-line {
      margin: 0.5rem;
      min-width: 98%;
      & .hefesto-textfield {
        max-height: 3rem;
      }
    }
  }
  & .middle-line {
    margin-top: 2rem;
  }
`;
